// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + __webpack_require__.h().slice(0, 16) + "-" + chunkId + ".css";
};